// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + ({"3421": "made-category-gallery","4098": "made-category-reviews","6565": "price-slider","7413": "made-category-carousel","7587": "made-reorder-modal",}[chunkId] || chunkId) + "-" + {"1626": "c54d1e47e4a90bf7","3421": "520c3bddca51089f","4098": "a6e2f3deacd1eb72","4513": "eb7e654c44d7fe3c","6565": "eeee93328bcf4dbb","7413": "f978e4fa2715b721","7587": "769cd41fcd771c41",}[chunkId] + ".chunk.css"
}